import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FadersHorizontal } from "@phosphor-icons/react";
import { DropdownMenuItem, OrgSwitcherContent, OrgSwitcherHeader } from "@hulahoop/ui";
import type { UserOrganization } from "@/domain/organization";
import { ROUTES } from "@/app/routes";
import { ShellOrganizationMark } from "./ShellOrganizationMark";
import { ShellOrganizationSwitch } from "./ShellOrganizationSwitch";

interface ShellOrganizationMenuProps {
  name: string;
  logoUrl?: string | null;
  organizations: UserOrganization[];
  selectedUuid: string | null;
  onSwitch: (uuid: string) => void;
}

export function ShellOrganizationMenu({
  name,
  logoUrl,
  organizations,
  selectedUuid,
  onSwitch,
}: ShellOrganizationMenuProps) {
  const { t } = useTranslation();
  return (
    <OrgSwitcherContent>
      <OrgSwitcherHeader
        logo={<ShellOrganizationMark name={name} logoUrl={logoUrl} size="md" />}
        name={name}
      />
      <DropdownMenuItem className="font-medium" render={<Link to={ROUTES.ORGANIZATION.GENERAL} />}>
        <FadersHorizontal /> {t("shell.organization_settings")}
      </DropdownMenuItem>
      <ShellOrganizationSwitch
        organizations={organizations}
        selectedUuid={selectedUuid}
        onSwitch={onSwitch}
      />
    </OrgSwitcherContent>
  );
}
